import { render, staticRenderFns } from "./CommercialProductCreate.vue?vue&type=template&id=2efe5e49&scoped=true&"
import script from "./CommercialProductCreate.vue?vue&type=script&lang=js&"
export * from "./CommercialProductCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efe5e49",
  null
  
)

export default component.exports